import { render, staticRenderFns } from "./OrgGroups.vue?vue&type=template&id=097dfea8&"
import script from "./OrgGroups.vue?vue&type=script&lang=js&"
export * from "./OrgGroups.vue?vue&type=script&lang=js&"
import style0 from "./OrgGroups.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports